<template>
  <div class="search-area container">
    <form>
      <div class="row">
        <div class="form-group col-4">
          <label>Tutor</label>
          <input
            v-model="tutorNameOrId"
            type="text"
            class="form-control w-75"
          >
        </div>
        <div class="form-group col-4">
          <label>Position</label>
        <PositionsInput v-model="positions"/>
        </div>
      </div>

      <div class="row">
        <div class="col-4 form-group">
          <label>Gender</label>
        <GendersInput v-model="genderCodes"/>
        </div>
        <div class="col-4 form-group">
          <label>Include Past Tutors</label>
          <div>
            <label class="checkbox">
              <input type="checkbox" v-model="isIncludeTerminationOfService">
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4 form-group">
          <label>Nationality</label>
          <NationalityInput
            v-model="nationality"
            class="form-control w-75"
          />
        </div>
      </div>
    </form>

    <div class="d-flex justify-content-end">
      <b-button pill variant="outline-secondary" @click="reset" class="mr-2" >
        Reset
      </b-button>
      <b-button pill variant="secondary" @click="search(1)">
        Search
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { TutorConditions } from '@/store/tutors/types'
import { Nationality, Position } from '@/store/master/types';
import PositionsInput from '@/components/parts/inputItem/PositionsInput.vue';
import GendersInput from '@/components/parts/inputItem/GendersInput.vue';
import NationalityInput from '@/components/parts/inputItem/NationalityInput.vue';

@Component({
  components: {
    PositionsInput,
    GendersInput,
    NationalityInput,
  },
})
export default class MailsSendBulkTutorsConditions extends Vue {
  @Prop() initialConditions!: TutorConditions

  private tutorNameOrId: string|null = null

  private positions: Position[] = []

  private isIncludeTerminationOfService: boolean = false

  private genderCodes: string[] = []

  private nationality: Nationality|null = null

  private created() {
    this.tutorNameOrId = this.initialConditions?.tutorNameOrId || null
    this.positions = this.initialConditions?.positions || []
    this.isIncludeTerminationOfService = this.initialConditions?.isIncludeTerminationOfService
      || false
    this.genderCodes = this.initialConditions?.genderCodes || []
    this.nationality = this.initialConditions?.nationality || null
  }

  /**
   * 検索条件変更
   */
  private search(): void {
    const conditions: TutorConditions = _.pickBy({
      tutorNameOrId: this.tutorNameOrId,
      positions: this.positions,
      isIncludeTerminationOfService: this.isIncludeTerminationOfService,
      genderCodes: this.genderCodes,
      nationality: this.nationality,
    })

    this.$emit('changeConditions', conditions)
  }

  /**
   * 検索条件をリセット
   */
  private reset(): void {
    this.tutorNameOrId = null
    this.positions = []
    this.isIncludeTerminationOfService = false
    this.genderCodes = []
    this.nationality = null

    this.search()
  }
}
</script>
